import {Component, OnDestroy, OnInit} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {delay, Observable, Subscription, timer} from 'rxjs';

import { SnackBarComponent } from 'src/app/shared/components/snack-bar/snack-bar.component';
import { defaultWarnDuartion, moduleNames } from '../../../shared/models/common';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {

  adminPageVersion?:string;
  isLoggedIn = false;
  username?: string;
  tokenExpireDate: number;
  logoutTimerSubscription?: Subscription;
  userInfoSubscription?: Subscription;

  constructor(private authService: AuthService,
              private snackBar: MatSnackBar,
              private translate: TranslateService,
              private router: Router) {
    this.tokenExpireDate = 0;
    translate.addLangs(['en', 'hu']);
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.authService.isLoggedIn().subscribe(isLoggedIn => {
      this.isLoggedIn = isLoggedIn;

      if (isLoggedIn) {
        this.userInfoSubscription = this.authService.userInfo$.subscribe(userInfo => {
          if (userInfo) {
            this.adminPageVersion = environment.adminPageVersion;
            this.username = userInfo.username;
            this.tokenExpireDate = (new Date(userInfo.tokenExpireDate * 1000).getTime() - new Date().getTime()) / 1000;

            this.logoutTimerSubscription?.unsubscribe();
            this.logoutTimerSubscription = timer(this.tokenExpireDate * 1000).subscribe(() => {
              this.logout();
            });
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this.logoutTimerSubscription?.unsubscribe();
    this.userInfoSubscription?.unsubscribe();
  }

  logout() {
    this.authService.logout()
      .subscribe((status) => {
        if (status) {
          this.snackBar.openFromComponent(SnackBarComponent, {
            data: 'APP.SNACK_BAR.ERROR.LOGOUT',
            duration: defaultWarnDuartion,
            panelClass: ['snack-bar', 'snack-bar--warn'],
          });
        }
      });
  }

  gotoMainPage() {
    this.router.navigate([moduleNames.station]);
  }

  changeLanguage(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedLang = selectElement.value;
    this.translate.use(selectedLang);
  }
}
